module.exports = __webpack_public_path__ + "2fb751f67898b5f8fe5268db7168c3f8.MP3";